import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from 'gatsby';

const Seo = ({ 
	title = null, 
	description = null, 
	image = null, 
	article = false, 
	noindex = false 
}) => {
	const { pathname } = useLocation();
	const { site } = useStaticQuery(query);

	const { defaultTitle, defaultDescription, siteUrl, defaultImage } = site.siteMetadata;

	const seo = {
		title: title || defaultTitle,
		description: description || defaultDescription,
		url: `${siteUrl}${pathname}`,
		image: image || defaultImage
	};

	return (
		<>
			<html lang="en-US" />

			<meta name="description" content={seo.description} />

			<meta property="og:locale" content="en_US" />

			{seo.url && <meta property="og:url" content={seo.url} />}

			<meta property="og:type" content={article ? 'article' : 'website'} />

			{seo.title && <meta property="og:title" content={seo.title} />}

			<meta property="og:description" content={seo.description} />

			<meta property="og:image" content={seo.image} />

			<meta name="twitter:card" content="summary_large_image" />

			<meta name="twitter:title" content={seo.title} />

			<meta name="twitter:description" content={seo.description} />

			<meta name="twitter:image" content={seo.image} />

			{noindex && <meta name="robots" content="noindex" />}
		</>
	);
};

export default Seo;

Seo.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	article: PropTypes.bool,
	noindex: PropTypes.bool
};

const query = graphql`
	query SEO {
		site {
			siteMetadata {
				defaultTitle: title
				defaultDescription: description
				siteUrl: url
				defaultImage: image
			}
		}
	}
`;
